module.exports = __webpack_public_path__ + "img/import.7071169e.svg";